import React, { useEffect, useState } from 'react';
import JoditEditor from 'jodit-react';
import { Button, Offcanvas } from 'react-bootstrap';

import '../../App.css';

import { useAddFilesMutation, useGetIndividualNoteListQuery } from '../../redux/apis/files';
import { useIsLoggedInQuery } from '../../redux/apis/authApi';

import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';
import { notification } from '../../utils/notification';
import './Notes.scss';

const { BTN_SAVE } = BT_BUTTON_LABELS;
const { TOAST_SUCCESS } = TOAST_TYPE;

function AdminNotes({ props }) {
  const { showDrawer, id, handleClose } = props;

  const initialState = {
    noteTitle: '',
    description: ''
  };
  const [state, setState] = useState(initialState);

  const { data } = useIsLoggedInQuery();
  const [addNote] = useAddFilesMutation();

  const {
    data: notesData,
    // isLoading,
    // isFetching,
    refetch
  } = useGetIndividualNoteListQuery({
    userId: id
  });

  useEffect(() => {
    // if (id) {
    //   refetch();
    // }
  }, [id]);

  useEffect(() => {
    if (notesData && notesData.data && notesData.data.length > 0) {
      const descriptions = notesData.data
        .map((note) => note.hrxNotes.map((note) => note.description).join('\n'))
        .join('\n');
      setState((prevState) => ({
        ...prevState,
        description: descriptions,
        isEditing: true
      }));
    }
  }, [notesData]);

  const handleSubmit = async () => {
    try {
      const hrxNotePayload = {
        createdBy: data?.data?._id,
        title: state.noteTitle,
        description: state.description
      };

      const payload = {
        userId: id,
        hrxNotes: hrxNotePayload
      };
      const response = await addNote(payload);
      if (response.data) {
        refetch();
        handleClose();
        setState(() => ({ ...state, description: '' }));
        notification(response?.data?.message, TOAST_SUCCESS);
      }
    } catch (error) {
      console.error('Error saving files:', error);
    }
  };

  return (
    <>
      <Offcanvas
        show={showDrawer}
        onHide={() => {
          setState((prevState) => ({ ...prevState, description: '' }));
          handleClose();
        }}
        placement="end"
        className="emp-notes"
      >
        <Offcanvas.Header closeButton className="emp-notes__header">
          <div>
            <Offcanvas.Title>Notes</Offcanvas.Title>
            <p className="emp-notes__hint">Write a note for this employee.</p>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="emp-notes__body">
          <div className="emp-notes__editor">
            <JoditEditor
              value={state.description}
              onChange={(content) => setState({ ...state, description: content })}
              tabIndex={1}
              onBlur={() => setState({ ...state, isEditorOpen: false })}
              minHeight="200px"
              className="joditNote"
            />
          </div>
          <div className="emp-notes__footer">
            <Button variant="primary" className="emp-notes__save" onClick={handleSubmit}>
              {BTN_SAVE}
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AdminNotes;
